export const hosting = {
  title: 'Webhosting',
  subtitle: 'Verwalte deine Webhosting-Pakete',
  loading: 'Lade Pakete...',
  buyPackage: 'Hosting-Paket bestellen',
  statuses: {
    provisioning: 'Wird bereitgestellt',
    active: 'Aktiv',
    failed: 'Fehlgeschlagen',
    suspended: 'Gestoppt',
    deprovisioned: 'Stillgelegt'
  },
  phases: {
    Pending: 'Ausstehend',
    Provisioning: 'Wird bereitgestellt',
    Running: 'Läuft',
    Maintenance: 'Wartungsmodus',
    Suspended: 'Pausiert',
    Error: 'Fehler'
  },
  empty: {
    title: 'Noch keine Webhosting-Pakete',
    description: 'Starte mit einem Hosting-Paket und bringe deine Website online.',
    cta: 'Paket bestellen'
  },
  tabs: {
    overview: 'Übersicht',
    sftp: 'Dateizugriff',
    databases: 'Datenbanken',
    settings: 'Einstellungen',
    logs: 'Logs',
    console: 'Konsole',
    cron: 'Cron',
    backups: 'Backups',
    access: 'Zugriff',
    actions: 'Aktionen'
  },
  delegation: {
    title: 'Delegierter Zugriff',
    subtitle: 'Anderen Benutzern Zugriff auf diese Website gewähren',
    addDelegate: 'Zugriff gewähren',
    empty: 'Keine delegierten Benutzer',
    emptyDescription: 'Gewähre anderen Benutzern Zugriff, um diese Website zu verwalten.',
    sharedWithMe: 'Für mich freigegeben',
    delegatedBy: 'Freigegeben von {email}',
    never: 'Nie',
    add: {
      title: 'Zugriff gewähren',
      subtitle: 'Einem anderen Benutzer Zugriff gewähren',
      email: 'E-Mail-Adresse',
      emailHint: 'Der Benutzer muss ein Konto auf diesem System haben',
      presets: 'Voreinstellungen',
      presetsHint: 'Schnellauswahl für häufige Berechtigungskombinationen',
      permissions: 'Berechtigungen',
      permissionsHint: 'Wähle die Berechtigungen, die der Benutzer erhalten soll',
      expiry: 'Ablaufdatum',
      expiryHint: 'Leer lassen für unbegrenzten Zugriff',
      noExpiry: 'Kein Ablaufdatum'
    },
    editModal: {
      title: 'Zugriff bearbeiten',
      subtitle: 'Berechtigungen für {email} anpassen'
    },
    deleteModal: {
      title: 'Zugriff entfernen',
      message: 'Bist du sicher, dass du den Zugriff von {email} auf diese Website entfernen möchtest?',
      warning: 'Der Benutzer wird sofort den Zugriff auf alle delegierten Funktionen verlieren.',
      confirm: 'Zugriff entfernen'
    },
    permissionLabels: {
      'hosting:sites:read': 'Website lesen',
      'hosting:sites:write': 'Website verwalten',
      'hosting:sites:delete': 'Website löschen',
      'hosting:backup:read': 'Backups lesen',
      'hosting:backup:write': 'Backups verwalten',
      'hosting:logs:read': 'Logs lesen'
    },
    permissionGroups: {
      site: 'Website',
      backups: 'Backups',
      logs: 'Logs'
    },
    presetLabels: {
      hosting_readonly: 'Nur Lesen',
      hosting_manage: 'Verwalten',
      hosting_full: 'Vollzugriff'
    },
    notifications: {
      added: 'Zugriff gewährt',
      addedMessage: '{email} hat jetzt Zugriff auf diese Website.',
      updated: 'Zugriff aktualisiert',
      updatedMessage: 'Die Berechtigungen wurden aktualisiert.',
      deleted: 'Zugriff entfernt',
      deletedMessage: '{email} hat keinen Zugriff mehr auf diese Website.',
      accountNotFound: 'Kein Konto mit dieser E-Mail-Adresse gefunden.',
      alreadyDelegate: 'Dieser Benutzer hat bereits Zugriff auf diese Website.',
      unexpectedResponse: 'Unerwartete Antwort vom Server. Bitte lade die Seite neu.'
    }
  },
  overview: {
    status: 'Status',
    runtime: 'Runtime',
    domains: 'Domains',
    webServer: 'Webserver',
    noDomains: 'Keine Domains',
    storage: 'Speicherverbrauch',
    restart: 'Neustart',
    restartSuccess: 'Site wird neu gestartet...',
    webspace: 'Webspace',
    database: 'Datenbanken',
    mail: 'E-Mail',
    otherSites: 'Andere Websites',
    thisSite: 'diese Website:'
  },
  settings: {
    runtimeTitle: 'Runtime & Webserver',
    runtimeHint: 'Ändert die PHP-Version oder den Webserver, mit dem deine Website läuft. Während der Umstellung ist deine Website ein paar Sekunden lang nicht erreichbar.',
    runtimeFieldHint: 'Empfohlen: die neueste PHP-Version, mit der deine Anwendung kompatibel ist. Neuere Versionen sind schneller und bekommen länger Sicherheitsupdates. Bei WordPress: aktuelle Versionen unterstützen alle PHP-Versionen ab 8.0; ältere Plugins/Themes evtl. nicht. „Static" deaktiviert PHP komplett — nur für reine HTML/JS/CSS-Seiten.',
    webServerFieldHint: 'Empfohlen: nginx — schneller und Standard für neue Sites. Apache nur wählen, wenn deine Anwendung explizit .htaccess-Regeln benötigt.',
    docrootLabel: 'Document-Root-Unterordner',
    docrootHint: 'Bei den meisten Sites leer lassen (WordPress, Drupal, einfaches PHP, statisches HTML). Auf „public" setzen, wenn deine Anwendung — etwa Laravel, Flarum oder Symfony — den Einstiegspunkt in einem public/-Unterordner hat.',
    docrootInvalid: 'Nur Unterordner — Buchstaben, Ziffern, _ und -, optional durch / getrennt. Kein führender Schrägstrich, kein Pfad-Traversal.',
    phpHint: 'Limits für PHP-Anwendungen. Höhere Werte erlauben größere Uploads und längere Skriptlaufzeiten, kosten aber mehr Speicher.',
    save: 'Speichern',
    saveConfirm: 'Beim Speichern ist deine Website kurz nicht erreichbar (wenige Sekunden während die neue Runtime startet). Fortfahren?',
    saved: 'Einstellungen gespeichert',
    savedHint: 'Deine Website wird kurz neu gestartet, damit die Änderungen wirksam werden.'
  },
  actions: {
    restart: {
      title: 'Website neu starten',
      hint: 'Startet die Software hinter deiner Website neu. Hilft, wenn deine Seite nicht mehr richtig reagiert oder hängenbleibt. Sie ist dabei ca. 5–15 Sekunden lang nicht erreichbar.',
      confirm: 'Deine Website ist für ca. 5–15 Sekunden nicht erreichbar. Jetzt neu starten?'
    },
    maintenance: {
      title: 'Wartungsmodus',
      hint: 'Zeigt allen Besuchern eine Wartungsseite statt deiner Website. Aktivieren z. B. für Updates oder Datenbankarbeiten.',
      messagePlaceholder: 'z. B. „Wartungsarbeiten bis 14:00"',
      messageHint: 'Optional. Wird zusammen mit der Standard-Wartungsmeldung angezeigt.',
      confirmEnable: 'Besucher sehen statt deiner Website eine Wartungsseite. Jetzt aktivieren?',
      confirmDisable: 'Wartungsmodus beenden? Deine Website ist anschließend wieder normal erreichbar.'
    },
    plan: {
      title: 'Plan ändern',
      hint: 'Wechsle zu einem anderen Hosting-Paket. Mehr Speicher, mehr Sites pro Paket.'
    },
    delete: {
      title: 'Website löschen',
      hint: 'Entfernt die Website unwiderruflich inkl. Dateien, Datenbanken und Backups. Diese Aktion kann nicht rückgängig gemacht werden.'
    }
  },
  sftp: {
    title: 'SFTP-Zugang',
    host: 'Host',
    port: 'Port',
    username: 'Benutzername',
    password: 'Neues Passwort',
    rotate: 'Passwort zurücksetzen',
    rotateConfirm: 'Aktuelle SFTP-Sitzungen werden beendet. Fortfahren?',
    rotateTitle: 'Passwort zurückgesetzt',
    rotateSuccess: 'Das neue Passwort wird einmalig angezeigt. Speichere es jetzt.',
    passwordOnceHint: 'Dieses Passwort wird nicht erneut angezeigt. Speichere es im Passwort-Manager.',
    hint: 'Klicke auf einen Wert um ihn zu kopieren. Verbinde dich mit FileZilla, Cyberduck oder WinSCP.',
    copied: 'Kopiert'
  },
  databases: {
    title: 'Datenbanken',
    name: 'Name',
    type: 'Typ',
    host: 'Host',
    database: 'Datenbank',
    username: 'Benutzername',
    password: 'Passwort',
    status: 'Status',
    actions: 'Aktionen',
    add: 'Datenbank hinzufügen',
    remove: 'Entfernen',
    credentials: 'Zugangsdaten',
    showCredentials: 'Zugangsdaten anzeigen',
    hideCredentials: 'Zugangsdaten ausblenden',
    rotatePassword: 'Passwort rotieren',
    rotateConfirm: 'Bist du sicher? Das aktuelle Passwort wird ungültig und deine Anwendung muss aktualisiert werden.',
    rotateSuccess: 'Passwort wird rotiert...',
    snippet: 'Config-Snippet',
    confirmRemove: 'Bist du sicher? Die Datenbank und alle Daten werden unwiderruflich gelöscht.',
    removeSuccess: 'Datenbank wird entfernt...',
    addSuccess: 'Datenbank wird erstellt...',
    empty: 'Noch keine Datenbanken konfiguriert.',
    ready: 'Bereit',
    notReady: 'Wird erstellt...',
    snippetFormats: {
      env: '.env',
      wordpress: 'WordPress',
      laravel: 'Laravel',
      php: 'PHP'
    },
    addDialog: {
      title: 'Datenbank hinzufügen',
      nameLabel: 'Name',
      nameHint: 'Beginnt mit einem Kleinbuchstaben, danach nur Kleinbuchstaben und Zahlen (max. 16 Zeichen)',
      namePlaceholder: 'z. B. wordpress',
      typeLabel: 'Typ',
      typeHint: 'Aktuell wird MariaDB angeboten (MySQL-kompatibel)',
      create: 'Erstellen',
      cancel: 'Abbrechen'
    }
  },
  php: {
    title: 'PHP-Einstellungen',
    save: 'Speichern',
    saveSuccess: 'PHP-Einstellungen gespeichert',
    presets: 'Vorlagen',
    preset: {
      default: 'Standard',
      wordpress: 'WordPress',
      laravel: 'Laravel'
    },
    settings: {
      upload_max_filesize: 'Max. Upload-Größe',
      post_max_size: 'Max. POST-Größe',
      max_execution_time: 'Max. Ausführungszeit',
      memory_limit: 'Speicherlimit',
      display_errors: 'Fehler anzeigen',
      error_reporting: 'Fehlerberichterstattung'
    },
    warnings: {
      title: 'Achtung — diese Kombination ist meistens nicht gewollt:',
      postSmallerThanUpload: 'Max. POST-Größe ist kleiner als Max. Upload-Größe. Datei-Uploads in dieser Größe schlagen still fehl. POST-Größe sollte mindestens so groß sein wie Upload-Größe.',
      memorySmallerThanPost: 'Speicherlimit ist kleiner als Max. POST-Größe. Beim Hochladen großer Dateien läuft PHP aus dem Speicher und bricht ab. Speicherlimit sollte mindestens so groß sein wie POST-Größe.',
      displayErrorsOn: '„Fehler anzeigen" ist auf On — PHP zeigt Fehlermeldungen mit Dateipfaden und ggf. Quelltext direkt im Browser. Sicherheitsrisiko: nur für Entwicklung, nicht für Produktion.'
    }
  },
  suspendedNotice: {
    title: 'Paket beendet, Website offline',
    body: 'Das Paket dieser Website ist beendet, deshalb ist sie offline. Bis einschließlich {date} erreichst du deine Dateien per SFTP und kannst Backups erstellen und herunterladen, die von jeder Datenbank einen SQL-Dump enthalten. Jedes Backup wird 72 Stunden aufbewahrt. Danach wird die Website gelöscht. Ein letztes Backup ihrer Dateien und Datenbanken wird noch 14 Tage aufbewahrt und danach ebenfalls gelöscht.',
    bodyUndated: 'Das Paket dieser Website ist beendet, deshalb ist sie offline. Bis 30 Tage nach dem Paketende erreichst du deine Dateien per SFTP und kannst Backups erstellen und herunterladen, die von jeder Datenbank einen SQL-Dump enthalten. Jedes Backup wird 72 Stunden aufbewahrt. Danach wird die Website gelöscht. Ein letztes Backup ihrer Dateien und Datenbanken wird noch 14 Tage aufbewahrt und danach ebenfalls gelöscht.'
  },
  errors: {
    siteSuspended: 'Das Paket dieser Website ist beendet. Du kannst ihre Daten noch sichern, die Website aber nicht mehr ändern.',
    packageEnded: 'Dieses Paket ist beendet. Du kannst ihm keine Websites mehr hinzufügen.',
    refused: 'Die Änderung wurde nicht gespeichert. Prüf deine Eingaben und versuch es erneut, und melde dich beim Support, wenn es weiter nicht klappt.'
  },
  maintenance: {
    title: 'Wartungsmodus',
    enable: 'Wartungsmodus aktivieren',
    disable: 'Wartungsmodus deaktivieren',
    message: 'Wartungsnachricht (optional)',
    active: 'Wartungsmodus aktiv',
    success: 'Wartungsmodus aktualisiert'
  },
  logs: {
    title: 'Logs',
    errorLogs: 'Fehler-Logs',
    accessLogs: 'Zugriffs-Logs',
    lines: 'Zeilen',
    timeRange: 'Zeitraum',
    autoRefresh: 'Auto-Aktualisierung',
    noLogs: 'Keine Logs im gewählten Zeitraum gefunden.',
    loading: 'Lade Logs...',
    refresh: 'Aktualisieren'
  },
  console: {
    title: 'Konsole',
    description: 'Einmalige Befehle direkt gegen deine Seite ausführen — z.B. composer install, php artisan migrate, wp core update.',
    workingDirLabel: 'Arbeitsverzeichnis',
    workingDirPlaceholder: '/app/public_html (Standard)',
    workingDirHint: 'Befehl wird ausgeführt unter {dir}',
    workingDirInvalid: 'Pfad muss /app/public_html oder ein Unterverzeichnis davon sein',
    commandLabel: 'Befehl',
    commandPlaceholder: 'php --version',
    runButton: 'Ausführen',
    stopButton: 'Stoppen',
    templates: 'Vorlagen',
    templatesEmpty: 'Vorlage wählen…',
    output: 'Ausgabe',
    noOutput: 'Keine Ausgabe — Befehl wird gestartet…',
    waiting: 'Wird gestartet…',
    succeeded: 'Beendet mit Exit-Code {code} (erfolgreich)',
    failed: 'Fehlgeschlagen (Exit-Code {code})',
    errorEvent: 'Fehler: {message}',
    disconnected: 'Verbindung zum Server verloren',
    recentRuns: 'Kürzlich ausgeführt',
    recentEmpty: 'Noch keine Ausführungen.',
    viewLogs: 'Logs anzeigen',
    status: {
      running: 'läuft',
      ok: 'OK',
      failed: 'Fehler'
    },
    conflictInFlight: 'Es läuft bereits ein Befehl auf dieser Seite. Bitte warte oder beende den aktuellen Befehl.',
    logsExpired: 'Logs sind nicht mehr verfügbar — der Job ist abgelaufen.'
  },
  cron: {
    title: 'Geplante Aufgaben',
    description: 'Cron-Jobs, die regelmäßig auf deiner Seite laufen — z. B. php artisan schedule:run, php flarum schedule:run oder Drupal-Cron.',
    empty: 'Noch keine Cron-Jobs angelegt.',
    addButton: 'Neuer Cron-Job',
    tableName: 'Name',
    tableSchedule: 'Zeitplan',
    tableCommand: 'Befehl',
    tableTimeout: 'Zeitlimit',
    tableConcurrency: 'Überlappung',
    tableActions: 'Aktionen',
    runs: 'Läufe',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    runsTitle: 'Läufe von {name}',
    runsEmpty: 'Keine Läufe gefunden. Die Laufhistorie wird ca. 24 Stunden aufbewahrt.',
    viewOutput: 'Ausgabe',
    runOutputEmpty: 'Keine Ausgabe für diesen Lauf gefunden.',
    modalAddTitle: 'Cron-Job hinzufügen',
    modalEditTitle: 'Cron-Job bearbeiten',
    fieldName: 'Name',
    fieldNameHint: 'Kurzname (Kleinbuchstaben, Ziffern, Bindestriche) — wird nach dem Anlegen nicht mehr geändert.',
    fieldNameInvalid: 'Name muss mit einem Kleinbuchstaben beginnen und darf nur Kleinbuchstaben, Ziffern und Bindestriche enthalten (max. 31 Zeichen).',
    fieldSchedule: 'Zeitplan',
    fieldScheduleHint: 'Standard-Cron-Ausdruck mit 5 Feldern (Minute Stunde Tag Monat Wochentag).',
    fieldScheduleInvalid: 'Ungültiger Zeitplan',
    fieldCommand: 'Befehl',
    fieldCommandHint: 'Wird als sh -c ausgeführt. Max. 4096 Zeichen.',
    fieldWorkingDir: 'Arbeitsverzeichnis',
    fieldWorkingDirHint: 'Optional. Pfad muss /app/public_html oder ein Unterverzeichnis sein. Leer = Standard.',
    fieldWorkingDirInvalid: 'Pfad muss /app/public_html oder ein Unterverzeichnis davon sein.',
    fieldTimeout: 'Zeitlimit (Sekunden)',
    fieldTimeoutHint: '10–3600 Sekunden, leer = 300',
    fieldConcurrency: 'Überlappung',
    concurrencyDefault: '(Standard — Forbid)',
    concurrencyForbid: 'Forbid — neuer Lauf wird übersprungen',
    concurrencyReplace: 'Replace — alter Lauf wird beendet',
    concurrencyAllow: 'Allow — Läufe können sich überschneiden',
    save: 'Speichern',
    cancel: 'Abbrechen',
    errorQuotaSite: 'Maximal 5 Cron-Jobs pro Website.',
    errorQuotaAccount: 'Maximal 30 Cron-Jobs pro Konto erreicht.',
    errorDuplicateName: 'Ein Cron-Job mit diesem Namen existiert bereits.',
    errorInvalidSchedule: 'Der Zeitplan konnte serverseitig nicht geparst werden.',
    errorGeneric: 'Cron-Job konnte nicht gespeichert werden.',
    successCreated: 'Cron-Job angelegt.',
    successUpdated: 'Cron-Job aktualisiert.',
    successDeleted: 'Cron-Job gelöscht.'
  },
  backups: {
    title: 'Backups',
    create: 'Backup erstellen',
    creating: 'Backup wird erstellt...',
    download: 'Herunterladen',
    downloadFiles: 'Dateien herunterladen',
    downloadDb: 'DB herunterladen',
    filesSize: 'Dateien',
    empty: 'Noch keine Backups erstellt.',
    rateLimitedHour: 'Du kannst ein Backup pro Stunde erstellen. Versuch es später erneut.',
    rateLimitedDay: 'Du kannst drei Backups in 24 Stunden erstellen. Versuch es später erneut.',
    busy: 'Für diese Website läuft noch ein Backup oder eine Wiederherstellung. Versuch es erneut, wenn es fertig ist.',
    limitReached: 'Diese Website hat schon {limit} Backups. Ein neues kannst du erstellen, sobald das älteste abläuft, 72 Stunden nach seiner Erstellung.',
    refused: 'Das Backup konnte nicht gestartet werden. Versuch es später erneut, und melde dich beim Support, wenn es weiter nicht klappt.',
    expiresAt: 'Läuft ab',
    size: 'Größe',
    dbSize: 'Datenbank',
    status: {
      in_progress: 'Läuft...',
      completed: 'Fertig',
      failed: 'Fehlgeschlagen'
    },
    restore: {
      button: 'Wiederherstellen',
      title: 'Aus Backup wiederherstellen',
      warning: 'Das überschreibt die Datenbanken aus diesem Backup. Vorher wird ein Backup ihres aktuellen Stands angelegt und hier aufgelistet, damit du zurück kannst.',
      restoreDb: 'Datenbank wiederherstellen',
      confirm: 'Wiederherstellen',
      cancel: 'Abbrechen',
      started: 'Wiederherstellung gestartet...',
      notRestorable: 'Nur ein fertiges Backup mit Datenbank lässt sich wiederherstellen.',
      limitReached: 'Diese Website wurde in den letzten 24 Stunden {limit}-mal wiederhergestellt. Versuch es erneut, sobald die älteste dieser Wiederherstellungen 24 Stunden zurückliegt.',
      history: 'Wiederherstellungen',
      fromBackup: 'aus dem Backup vom {date}',
      fromBackupExpired: 'aus einem inzwischen abgelaufenen Backup',
      safetyBackup: 'Stand vor der Wiederherstellung: Backup vom {date}',
      safetyBackupExpired: 'Das Backup des Stands vor der Wiederherstellung ist abgelaufen',
      status: {
        in_progress: 'Wird wiederhergestellt...',
        completed: 'Wiederhergestellt',
        failed: 'Fehlgeschlagen'
      }
    }
  },
  delete: {
    button: 'Seite löschen',
    confirm: 'Bist du sicher? Die Seite und alle zugehörigen Daten werden unwiderruflich gelöscht. Gib den Seitennamen zur Bestätigung ein.',
    success: 'Seite wird gelöscht...'
  },
  upgrade: {
    button: 'Wechseln',
    title: 'Hosting-Plan ändern',
    current: 'Aktueller Plan',
    noOptions: 'Keine Upgrade-Optionen verfügbar.',
    success: 'Plan erfolgreich aktualisiert',
    ownerOnly: 'Das Paket kann nur der Inhaber des Vertrags wechseln.',
    billingPeriodUnknown: 'Den Abrechnungszeitraum dieses Pakets können wir gerade nicht bestimmen. Bitte wende dich an service{\'@\'}itsh.dev.'
  },
  package: {
    title: 'Paket',
    quota: '{used} von {total} belegt',
    overage: '{amount} über Paket-Kontingent — Zusatzspeicher wird nachberechnet',
    addSite: 'Website hinzufügen',
    sitesCount: 'keine Websites | {count} Website | {count} Websites',
    noSites: 'Noch keine Website in diesem Paket'
  },
  addSite: {
    title: 'Neue Website{package}',
    successTitle: 'Website angelegt',
    successMessage: '{name} wurde deinem Paket hinzugefügt',
    submit: 'Website anlegen',
    fields: {
      name: 'Name',
      nameHint: 'Kurzname (Kleinbuchstaben, Ziffern, Bindestriche)',
      domains: 'Domains',
      domainsPlaceholder: 'beispiel.de, www.beispiel.de',
      domainsHint: 'Komma- oder leerzeichengetrennt. Registrierte Domains oder Subdomains deiner Domains (z. B. freebie.deine-domain.de).',
      runtime: 'Runtime',
      webServer: 'Webserver',
      redirects: 'Weiterleitungen',
      redirectsHint: 'Optional: Leite zusätzliche Hostnamen per 301/302/308 auf eine Primärdomain um.'
    },
    redirect: {
      add: 'Weiterleitung',
      remove: 'Entfernen',
      fromPlaceholder: 'www.deine-domain.de'
    },
    errors: {
      nameRequired: 'Name ist erforderlich',
      domainRequired: 'Mindestens eine Domain ist erforderlich',
      redirectIncomplete: 'Jede Weiterleitung benötigt Quelle und Ziel.',
      redirectTargetNotPrimary: 'Ziel muss eine der Primärdomains sein.'
    }
  },
  siteDetail: {
    dnsTitle: 'DNS-Einträge',
    dnsHint: 'Jeder Hostname dieser Website, auch Quellen von Weiterleitungen, braucht beide Einträge beim DNS-Anbieter seiner Domain. Sie werden nicht automatisch gesetzt.',
    dnsCopy: 'Kopieren',
    redirectsTitle: 'Weiterleitungen',
    redirectsHint: 'Leite weitere Hostnamen per 301/302/308 auf eine Primärdomain um.',
    addRedirect: 'Weiterleitung hinzufügen',
    removeRedirect: 'Entfernen',
    saveRedirects: 'Weiterleitungen speichern',
    redirectsSaved: 'Weiterleitungen aktualisiert',
    redirectsSaveError: 'Weiterleitungen konnten nicht gespeichert werden',
    additionalHostnamesTitle: 'Zusätzliche Hostnamen',
    additionalHostnamesHint: 'Subdomains, die diese Seite ausliefert (z. B. www.beispiel.de). Die Domain (beispiel.de) muss zu deinem Konto gehören.',
    addAdditionalHostname: 'Hostname hinzufügen',
    removeAdditionalHostname: 'Entfernen',
    saveAdditionalHostnames: 'Hostnamen speichern',
    additionalHostnamesSaved: 'Hostnamen aktualisiert',
    additionalHostnamesSaveError: 'Hostnamen konnten nicht gespeichert werden',
    refusals: {
      hostnameNotOwned: 'Dieser Hostname liegt unter keiner Domain, die zu deinem Konto gehört.',
      redirectSourceNotOwned: 'Diese Weiterleitungsquelle liegt unter keiner Domain, die zu deinem Konto gehört.',
      redirectTarget: 'Eine Weiterleitung muss auf einen anderen Hostnamen zeigen, den diese Website schon ausliefert.',
      redirectSourceServed: 'Diese Weiterleitungsquelle liefert die Website schon selbst aus, oder sie steht doppelt in der Liste.',
      redirectStatus: 'Eine Weiterleitung muss den Status 301, 302 oder 308 verwenden.',
      hostnameRedirectTarget: 'Eine Weiterleitung zeigt noch auf diesen Hostnamen. Ändere oder entferne zuerst die Weiterleitung.'
    }
  },
  mailSender: {
    title: 'E-Mail-Versand aus PHP',
    active: {
      intro: 'PHP mail() verschickt die E-Mails dieser Website über unseren Mailserver, auch aus Cronjobs und der Konsole. Absender ist diese Adresse:',
      copy: 'Kopieren',
      hourlyLimit: 'Höchstens {count} Empfänger pro Stunde.',
      dailyLimit: 'Höchstens {count} Empfänger pro Tag.',
      fromRule: 'Die From-Adresse muss auf der Domain der Website liegen, also auf {domain} oder einer Subdomain davon.',
      replyToRule: 'Adressen von Besuchern, etwa aus einem Kontaktformular, gehören in Reply-To, nicht in From.',
      refused: 'Eine abgelehnte E-Mail kommt in keine Warteschlange: mail() gibt dann false zurück.'
    },
    pending: 'Der E-Mail-Versand für diese Website wird gerade eingerichtet.',
    unavailable: {
      generic: 'Diese Website kann gerade keine E-Mails aus PHP versenden.',
      no_custom_domain: {
        text: 'Füge der Website eine eigene Domain hinzu, um E-Mails aus PHP zu versenden.'
      },
      mail_elsewhere: {
        text: 'Die E-Mails dieser Domain liegen bei einem anderen Anbieter. Nutze ein SMTP-Plugin mit den Zugangsdaten deines Mailanbieters.',
        textDomain: 'Die E-Mails von {domain} liegen bei einem anderen Anbieter. Nutze ein SMTP-Plugin mit den Zugangsdaten deines Mailanbieters.',
        link: 'Zur Anleitung'
      },
      mail_off: {
        text: 'E-Mail ist für diese Domain ausgeschaltet oder nicht enthalten.',
        textDomain: 'E-Mail ist für {domain} ausgeschaltet oder nicht enthalten.',
        link: 'E-Mail-Einstellungen öffnen'
      },
      domain_unverified: {
        text: 'Die Domain ist für E-Mail noch nicht verifiziert. Verifiziere sie zuerst.',
        textDomain: '{domain} ist für E-Mail noch nicht verifiziert. Verifiziere die Domain zuerst.',
        link: 'Domain verifizieren'
      },
      dns_incomplete: {
        text: 'Für diese Domain fehlt der SPF- oder DKIM-Eintrag.',
        textDomain: 'Für {domain} fehlt der SPF- oder DKIM-Eintrag.',
        link: 'Mail-DNS einrichten'
      },
      site_suspended: {
        text: 'Die Website ist gestoppt und kann keine E-Mails versenden.'
      },
      static_runtime: {
        text: 'Statische Websites führen kein PHP aus und haben deshalb keinen Mail-Absender.'
      }
    }
  }
} as const
